import React from 'react';
import { Navigate } from 'react-router-dom';
import { AppLinks } from '../consts/app-links.enum';
import { UserRoleEnum, userStore } from 'entities/index';
import { observer } from 'mobx-react';

interface RoleGuardProps {
  Component: React.ComponentType;
  acceptedRoles: UserRoleEnum[];
}

const RoleGuard: React.FC<RoleGuardProps> = observer(
  ({ Component, acceptedRoles }) => {
    const userRole: UserRoleEnum = userStore.role;

    return acceptedRoles.includes(userRole) ? (
      <Component />
    ) : (
      <Navigate to={AppLinks.AboutLink} />
    );
  }
);

export default RoleGuard;
